import input from '@/components/input'

/**
 * @module
 * @name InputTextDescription
 * @extends Input
 */
export default {
  name: 'InputTextDescription',
  extends: input,
  data: function () {
    return {
      inputHasFocus: false
    }
  },

  /**
   * @property {String} icon VueSVGicon
   * @property {String} placeholder Placeholder to show while input is empty.
   * @property {String} type Text input could also be of type number, password.
   * @property {Boolean} removeIcon If true, shows X to delete input content.
   */
  props: {
    icon: {
      type: String,
      required: false
    },
    placeholder: {
      type: String,
      required: false
    },
    type: {
      type: String,
      required: false,
      validator: (v) => ['text', 'password', 'number'].indexOf(v) !== -1,
      default: 'text'
    },
    removeIcon: {
      type: Boolean,
      required: false,
      default: false
    },
    inputError: {
      type: Boolean | Number,
      required: false
    },
    InputTextDescriptionError: {
      type: String,
      required: false
    },
    placeHolderInput: {
      type: String,
      required: false
    }
  },

  /**
   * @property {Boolean} showRemoveIcon  Returns if removeIcon should be showed.
   */
  computed: {
    showRemoveIcon: function () {
      return this.removeIcon && this.value && this.value.length > 0
    }
  }
}
